import { render, staticRenderFns } from "./GeneralPrinciple.vue?vue&type=template&id=d31e4fee&scoped=true"
import script from "./GeneralPrinciple.vue?vue&type=script&lang=js"
export * from "./GeneralPrinciple.vue?vue&type=script&lang=js"
import style0 from "./GeneralPrinciple.vue?vue&type=style&index=0&id=d31e4fee&prod&scoped=true&lang=css"
import style1 from "./GeneralPrinciple.vue?vue&type=style&index=1&id=d31e4fee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31e4fee",
  null
  
)

export default component.exports